import { useTranslation } from 'react-i18next';

import { UserRole } from '../../../types/User';
import { StyledChip } from './styled';

/*
 * This component shows a badge next to the user's profile picture, for admin and auditor users.
 */

interface Props {
    type: UserRole;
}

const Badge = (props: Props) => {
    const { type } = props;

    const { t } = useTranslation();

    if (type === 'auditor') {
        return (
            <StyledChip label={t('user_types_badge.auditor')} variant='outlined' />
        );
    }

    if (type === 'certifier') {
        return (
            <StyledChip label={t('user_types_badge.certifier')} variant='outlined' />
        );
    }

    if (type === 'admin') {
        return (
            <StyledChip label={t('user_types_badge.admin')} color='primary' style={{ color: '#ffffff' }} />
        );
    }

    return null;
};

export default Badge;
